module.exports = new __parcel__URL__("noPlace.eb10bd7b.ogg").toString();